export const formatCodigo = (codigo: string | null | undefined): string => {
  if (!codigo) return '—';
  const digits = codigo.replace(/\D/g, '');
  if (digits.length === 14) {
    return digits.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
  }
  return codigo;
};

export const formatBRL = (value: number | null | undefined): string => {
  if (value == null) return '—';
  return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
};

export const formatPercent = (value: number | null | undefined): string => {
  if (value == null) return '—';
  return `${(value * 100).toFixed(2)}%`;
};

export const formatQtd = (value: number | null | undefined): string => {
  if (value == null) return '—';
  return value.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 6 });
};

export const formatRentSimples = (value: number | null | undefined): string => {
  if (value == null) return '—';
  const pct = value * 100;
  return `${pct >= 0 ? '+' : ''}${pct.toFixed(4)}%`;
};

export const formatDate = (iso: string): string => {
  if (!iso) return '—';
  const [y, m, d] = iso.split('-');
  return `${d}/${m}/${y}`;
};
